import { jsx } from "react/jsx-runtime";
import { memo, forwardRef } from "react";
import { IconBase } from "src/components/ui/IconBase";
export default memo(forwardRef(function IconSvgPlus({
  className,
  "data-test-id": dataTest = "IconPlus",
  ...props
}, ref) {
  return /* @__PURE__ */ jsx(IconBase, { ...props, "data-test-id": dataTest, className, innerRef: ref, children: /* @__PURE__ */ jsx("svg", { viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ jsx("path", { d: "M7.3335 7.33331V3.33331H8.66683V7.33331H12.6668V8.66665H8.66683V12.6666H7.3335V8.66665H3.3335V7.33331H7.3335Z", fill: "#0076E1" }) }) });
}));
